import React, {
  type ReactElement,
  type ReactNode,
  useContext,
  useImperativeHandle,
} from "react";
import { StepsContext } from "src/shared/forms/steps/StepsContext";

export interface IStepProps {
  name: ReactNode;
  onNextClick?: () => Promise<void>;
  children: ReactNode | (() => ReactElement);
}

export const Step = ({ onNextClick, children }: IStepProps) => {
  const stepsContext = useContext(StepsContext);
  useImperativeHandle(stepsContext.onNextClickRef, () => onNextClick, [
    onNextClick,
  ]);
  return <>{typeof children === "function" ? children() : children}</>;
};

/**
 * @deprecated
 */
export default Step;
